import { TaxSectionProps } from ".";
import { InputButton } from "../../components/Forms/InputButton";
import { Text } from "../../components/Forms/InputButton/styles";
import { SelectButton } from "../../components/Forms/SelectButton";
import { BankSlipConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { BankSlipIcon } from "../../styles/icons/BankSlipIcon";
import { Rewind } from "../../styles/icons/Rewind";
import { clearMask, formatCurrency, formatCurrencyToApiNoThrow, getRateTypeValue } from "../../utils";
import { formatPaymentRangeFromApi, formatPaymentRangeToApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Divider, Header, Section } from "./styles";

interface BankSlipSectionProps extends TaxSectionProps {
  bankSlipConfigData: BankSlipConfig;
  defaultBankSlipConfigData: BankSlipConfig;
}

export function BankSlipSection({
  editionMode = false,
  bankSlipConfigData,
  asModalView,
  defaultBankSlipConfigData,
  register,
  errors,
  watch,
  setValue,
  colorFinder
}: BankSlipSectionProps) {
  const delayForRedeem = formatTextView("bankSlipDelayForRedeem", "delayForRedeem", formatPaymentRangeFromApi);
  const value = formatBankSlipValueView("bankSlipValue", "value", watch);
  const bankSlipLimitValue = formatTextView("rateLimitValue", "rateLimitValue", formatCurrency, true);
  const rateType = formatTextView("rateType", "rateType", getRateTypeValue, false, true);
  function handleSetDefaultValue(name: string, defaultValue: string, func: any) {
    const convertionFunction = {
      "range": formatPaymentRangeFromApi,
      "currency": (value) => formatCurrency({ value })
    }
    setValue(name, convertionFunction[func](defaultBankSlipConfigData[defaultValue]))
  }
  function formatTextView(auxName: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean, formaterAsRateType?: boolean): JSX.Element {
    const defaultValueFormatted = formaterAsCurrency ? formater({ value: defaultBankSlipConfigData[innerValue] }) : formater(defaultBankSlipConfigData[innerValue]);
    if(!bankSlipConfigData[innerValue]) return
    const pastValue = formaterAsCurrency ? formater({ value: bankSlipConfigData[innerValue] }) : formater(bankSlipConfigData[innerValue]);
    const laterValue = formaterAsRateType ? formater(defaultBankSlipConfigData[innerValue]) : watch(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }

  function formatBankSlipValueView(auxName: string, defaultValue: string, getValue: any) {
    const defaultRateType = defaultBankSlipConfigData["rateType"];
    const defaultValueFormatted = defaultRateType === "percent" ? formatPercentageToNumber(bankSlipConfigData[defaultValue]) : formatCurrency({ value: defaultBankSlipConfigData[defaultValue] });
    const pastValue: any = defaultRateType === "percent" ? formatPercentageToNumber(bankSlipConfigData[defaultValue]) : formatCurrency({value: bankSlipConfigData[defaultValue]});
    const laterValue: any = getValue(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13} />
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  return (
    <Section flexDir="column">
      <Section gap=".4rem" margin={asModalView ? "1rem 0 0" : ""}>
        <BankSlipIcon />
        <Header>Boleto</Header>
      </Section>
      {!asModalView && (
        <Section>
          <InputButton
            disabled={!editionMode}
            label="Tempo de repasse"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            name="bankSlipDelayForRedeem"
            mask="paymentRange"
            register={{ ...register("bankSlipDelayForRedeem") }}
            defaultValue={formatPaymentRangeFromApi(watch("bankSlipDelayForRedeem"))}
            buttonFunction={() => handleSetDefaultValue("bankSlipDelayForRedeem", "delayForRedeem", "range")}
            color={() => colorFinder(formatPaymentRangeToApi(watch("bankSlipDelayForRedeem")), defaultBankSlipConfigData?.delayForRedeem)}
            buttonDisabled={formatPaymentRangeToApi(watch("bankSlipDelayForRedeem")) === defaultBankSlipConfigData?.delayForRedeem}
            icon={<Rewind color={formatPaymentRangeToApi(watch("bankSlipDelayForRedeem")) === defaultBankSlipConfigData?.delayForRedeem ? "#00000040" : "black"} />}
            errors={errors?.bankSlipDelayForRedeem}
          />
          <InputButton
            disabled={!editionMode}
            label="Taxa"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            mask={watch("rateType") === "percent" ? "percentageRacional" : "currencyE"}
            name="bankSlipValue"
            register={{ ...register("bankSlipValue") }}
            defaultValue={watch("rateType") === "percent" ? formatPercentageToNumber(watch("bankSlipValue")) : formatCurrency({value: watch("bankSlipValue")})}
            buttonFunction={() => watch("rateType") === "percent" ? setValue("bankSlipValue", formatPercentageToNumber(4.29)) : setValue("bankSlipValue", formatCurrency({value: 0.8}))}
            color={() => colorFinder(formatCurrencyToApiNoThrow(watch("bankSlipValue")), defaultBankSlipConfigData?.rateType === "percent" ? defaultBankSlipConfigData?.rate : defaultBankSlipConfigData?.value)}
            buttonDisabled={formatCurrencyToApiNoThrow(watch("bankSlipValue")) === (defaultBankSlipConfigData?.rateType === "percent" ? defaultBankSlipConfigData?.rate : defaultBankSlipConfigData?.value)}
            icon={<Rewind color={formatCurrencyToApiNoThrow(watch("bankSlipValue")) === (defaultBankSlipConfigData?.rateType === "percent" ? defaultBankSlipConfigData?.rate : defaultBankSlipConfigData?.value) ? "#00000040" : "black"} />}
            errors={errors?.bankSlipValue}
          />
          <InputButton
            disabled={!editionMode || watch("rateType") === "value"}
            label="Limite de taxas"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            mask="currencyE"
            name="rateLimitValue"
            register={{ ...register("rateLimitValue") }}
            defaultValue={formatCurrencyToApiNoThrow(watch("rateLimitValue"))}
            buttonFunction={() => handleSetDefaultValue("rateLimitValue", "value", "currency")}
            color={defaultBankSlipConfigData?.rateLimitValue ?
              colorFinder(formatCurrencyToApiNoThrow(watch("rateLimitValue")), defaultBankSlipConfigData?.rateLimitValue) :
              colorFinder(formatCurrencyToApiNoThrow(watch("rateLimitValue")), defaultBankSlipConfigData?.value)
            }
            buttonDisabled={defaultBankSlipConfigData?.rateLimitValue ?
              watch("rateType") === "value" || formatCurrencyToApiNoThrow(watch("rateLimitValue")) === defaultBankSlipConfigData?.rateLimitValue :
              watch("rateType") === "value" || formatCurrencyToApiNoThrow(watch("rateLimitValue")) === defaultBankSlipConfigData?.value
            }
            icon={
              <Rewind color={defaultBankSlipConfigData?.rateLimitValue ? 
                formatCurrencyToApiNoThrow(watch("rateLimitValue")) === defaultBankSlipConfigData?.rateLimitValue ? "#00000040" : "black" :
                formatCurrencyToApiNoThrow(watch("rateLimitValue")) === defaultBankSlipConfigData?.value ? "#00000040" : "black"
              } />
            }
            errors={errors?.rateLimitValue}
          />
          <SelectButton
            name="rateType"
            disabled={!editionMode}
            label="Tipo de taxa"
            variant="ghost"
            bgColor="#EDF1F7"
            h="27px"
            width={asModalView ? "120px" : ""}
            tooltipButtonText="Redefinir para o valor padão"
            defaultValue={watch("rateType") ?? "percent"}
            buttonFunction={() => setValue("rateType", defaultBankSlipConfigData?.rateType)}
            color={() => colorFinder(watch("rateType"), defaultBankSlipConfigData?.rateType)}
            buttonDisabled={watch("rateType") === defaultBankSlipConfigData?.rateType}
            icon={<Rewind color={watch("rateType") === defaultBankSlipConfigData?.rateType ? "#00000040" : "black"} />}
            errors={errors?.rateType}
            register={{...register("rateType")}}
          >
            <option value="value">Taxa fixa</option>
            <option value="percent">Porcentagem</option>
          </SelectButton>
        </Section>
      )}
      {asModalView && (
        <Section flexDir="column">
          <Section> 
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tempo de repasse
              </Text>
              {delayForRedeem}
            </Section>
            <Section flexDir="column" gap=".1rem">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Taxa
              </Text>
              {value}
            </Section>
          </Section>

          <Section>
            <Section flexDir="column">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Limite de taxas
              </Text>
              {bankSlipLimitValue}
            </Section>
            <Section flexDir="column">
              <Text fontSize=".8rem" color="var(--gray-400)">
                Tipo de taxa
              </Text>
              {rateType}
            </Section>
          </Section>
        </Section>
      )}
      <Divider />
    </Section>
  )
}